var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.632,
    height: 8.938,
    viewBox: "0 0 15.632 8.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-down",
    "data-name": "arrow-down",
    d: "M14.006,17.49l5.911-5.915a1.112,1.112,0,0,1,1.578,0,1.126,1.126,0,0,1,0,1.582l-6.7,6.7a1.115,1.115,0,0,1-1.54.033l-6.744-6.73a1.117,1.117,0,0,1,1.578-1.582Z",
    transform: "translate(-6.188 -11.246)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.55fcf696b6c2dbb7cbfd1a4b88b3e98b.svg";
export { ForwardRef as ReactComponent };